import React from "react";
import '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faReact, faDocker, faPython,faAngular,faLaravel,faSymfony,faGit,faJenkins,faDebian,faUbuntu} from '@fortawesome/free-brands-svg-icons';
import Chip from '@mui/material/Chip';
import '../assets/styles/Expertise.scss';

const labelsFirst = [
    "Angular",
    "React",
    "Vue.js",
    "Laravel",
    "Symfony",
    "Nest.js",
    "Adonis.js",
    "TypeScript",
    "JavaScript",
    "Google app script",
    "HTML5",
    "CSS3",
    "SASS",
    "Python",
    "SQL",
    "MongoDb",
    "Mysql",
    "PostgreSQL"
];

const labelsSecond = [
    "Git",
    "Jenkins",
    "Docker",
    "kubernates",
    "AWS",
    "Linux",
    "Pandas",
    "Selenium",
    "Behat",
    "Cypress"
];

const labelsThird = [
    "OpenAI",
    "Groq",
    "N8N",
    "Google Colab",
    "Google Cloud",
    "PyTorch",
    "Microsoft Power BI"
];

function Expertise() {
    return (
    <div className="container" id="expertise">
        <div className="skills-container">
            <h1>Expertises</h1>
            <div className="skills-grid">
                <div className="skill">
                    <div className="flex-space-between">
                        <FontAwesomeIcon icon={faLaravel} size="3x"/>
                        <FontAwesomeIcon icon={faSymfony} size="3x"/>
                        <FontAwesomeIcon icon={faPython} size="3x"/>
                        <FontAwesomeIcon icon={faAngular} size="3x"/>
                        <FontAwesomeIcon icon={faReact} size="3x"/>
                    </div>
                    <h3>Développement Web Full Stack</h3>
                    <p>
                        J'ai développé de A à Z une grande variété d'applications web en utilisant des technologies modernes comme Angular et Laravel. Je maîtrise parfaitement le cycle de vie du développement logiciel (SDLC), les bonnes pratiques (SOLID) et le développement front-end et back-end.
                    </p>
                    <div className="flex-chips">
                        <span className="chip-title">Satck Technique:</span>
                        {labelsFirst.map((label, index) => (
                            <Chip key={index} className='chip' label={label} />
                        ))}
                    </div>
                </div>

                <div className="skill">
                    <div className="flex-space-between">
                        <FontAwesomeIcon icon={faDebian} size="3x"/>
                        <FontAwesomeIcon icon={faUbuntu} size="3x"/>
                        <FontAwesomeIcon icon={faDocker} size="3x"/>
                        <FontAwesomeIcon icon={faGit} size="3x"/>
                        <FontAwesomeIcon icon={faJenkins} size="3x"/>
                    </div>

                    <h3>DevOps & Automation</h3>
                    <p>
                        Une fois l'application créée, j'aide les clients à créer des environnements de tests et de production en configurant des vps sous debian ou ubuntu, à mettre en place des tests DevOps, des pipelines CI/CD et l'automatisation du déploiement pour soutenir la réussite de la mise en service.
                    </p>
                    <div className="flex-chips">
                        <span className="chip-title">Tech stack:</span>
                        {labelsSecond.map((label, index) => (
                            <Chip key={index} className='chip' label={label} />
                        ))}
                    </div>
                </div>

                <div className="skill">
                    <FontAwesomeIcon icon={faPython} size="3x"/>
                    <h3>GenAI, LLM & BI </h3>
                    <p>
                        Restez compétitif sur le marché en exploitant les derniers modèles d'IA dans vos projets.
                        J'ai une expérience professionnelle dans la création de solutions GenAI de niveau entreprise pour une prise de décision intelligente.
                    </p>
                    <div className="flex-chips">
                        <span className="chip-title">Tech stack:</span>
                        {labelsThird.map((label, index) => (
                            <Chip key={index} className='chip' label={label} />
                        ))}
                    </div>
                </div>
            </div>
        </div>
    </div>
    );
}

export default Expertise;